function getValidatedDate({ date, respectTimezone }) {
  // number as timestamp
  if (date === null || typeof date === "number") {
    return date
  }

  // Validate String Input
  if (typeof date === "string") {
    if (date && Number.isNaN(new Date(date).getTime())) {
      throw new TypeError("The date parameter is invalid")
    }
    let mutatedDate = date.trim()

    const regexFormat = /\b\d{4}-\d{2}\b/; // check year and month

    if (regexFormat.test(date)) {
      mutatedDate = mutatedDate.replace(" ", "T")

      // incase datetime
      if (mutatedDate.includes("T") && mutatedDate.split("T").length === 2) {
        if ((respectTimezone || respectTimezone === undefined) && !mutatedDate.includes("Z")) {
          mutatedDate = `${mutatedDate}Z`
        }

        if (respectTimezone === false && mutatedDate.includes("Z")) {
          mutatedDate = mutatedDate.replace("Z", "")
        }
      }

      // incase date
      if (!mutatedDate.includes("T") && !mutatedDate.includes("Z")) {
        mutatedDate = `${date}T00:00:00`
      }
      return mutatedDate
    }

    return mutatedDate
  }

  // Validate Date Object
  if (date instanceof Date) {
    if (Number.isNaN(date.getTime())) {
      throw new Error("Invalid Date object provided.");
    }
    return date;
  }

  // Validate Components (Array) Input
  if (Array.isArray(date)) {
    const [year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0] = date;

    if (
      [year, month, day, hours, minutes, seconds, milliseconds].some((val) => typeof val !== "number")
    ) {
      throw new Error("Invalid components provided. Expected an array of numbers.");
    }

    return date
  }

  throw new Error(
    `Invalid input type for 'date'. Expected string, number, Date, or an array of components. Received: ${typeof date}`,
  )
}

export default function newDateWrapper(date = null, options = {}) {
  const validatedDate = getValidatedDate({ date, respectTimezone: options?.respectTimezone })

  // No input: Return the current date
  if (validatedDate === null) {
    return new Date();
  }

  if (validatedDate instanceof Date) {
    return validatedDate;
  }

  if (Array.isArray(validatedDate)) {
    const [year, month, day, hours = 0, minutes = 0, seconds = 0, milliseconds = 0] = validatedDate;
    return new Date(year, month, day, hours, minutes, seconds, milliseconds);
  }
  return new Date(validatedDate)
}
